import React, { useState, useEffect, useContext, useRef } from 'react';
import { Container, StyledHeader, HeaderLogo, Menu, Nav, NavMenu, NavItem, CTAs, IconsGroup, Icon, IconStart, IconClose,
    SearchBar, SearchForm, SideNavContainer, ButtonsGroup, LoggedIn, User, UserImage, UserMenu, FirstName, LogOut, Login, CampaingButtons, CampaingBtn } from './header.style';
import MainNav from './MainNav/MainNav';
import SideNav from './SideNav/SideNav';
import LanguageBar from './LanguageBar/LanguageBar';
import CookieBar from './CookieBar/CookieBar';
import  { Link, useLocation } from 'react-router-dom';
import DropdownButton from 'components/common/Button/DropdownButton/DropdownButton';
import {ConfigContext} from 'context/AppContext';
import helper from 'components/utils/helper';
import SearchInput from './SearchInput/searchInput'

const Header = ({cms}) => {
    let configContext = useContext(ConfigContext);
    let config = configContext.config;
    let location = useLocation();

    const [headerVisible, setHeaderVisible] = useState(true);
    const [activeMenu, setActiveMenu] = useState(null);
    const [isHoverNav, setIsHoverNav] = useState(false);
    const [searching, setSearching] = useState(false);
    const [loggedIn, setLoggedIn] = useState(helper.getCookie('movember-produs-2016_logged') === '1');
    const [userMenuVisible, setUserMenuVisible] = useState(false);
    const { ref, isComponentVisible, setIsComponentVisible } = helper.useComponentVisible(false);
    const isOnMobile = helper.isOnMobile();
    const [headerHeight, setHeaderHeight] = useState((isOnMobile && !loggedIn) ? '138px' : '75px');
    const [cookieEnabled, setCookieEnabled] = useState(false);

    const [logoDesktop, setLogoDesktop] = useState('/resources/images/global/movember_logo_primary.svg');
    const [logoMobile, setLogoMobile] = useState('/resources/images/global/movember_logo.png');
    const [logoUrl, setLogoUrl] = useState(helper.getUrl('/', config.getLanguage()));
    const [loginText, setLoginText] = useState('Login');
    const [loginUrl, setLoginUrl] = useState('/login');
    const [registerText, setRegisterText] = useState('Sign Up');
    const [registerUrl, setRegisterUrl] = useState('/register');
    const [donateText, setDonateText] = useState('Donate');
    const [donateOptions, setDonateOptions] = useState([]);
    
    // Close user menu when click outside of the menu
    const clickOutsideWrapperRef = useRef(null);
    helper.useClickOutside(clickOutsideWrapperRef, () => setUserMenuVisible(false));

    useEffect(() => {
        // Scroll to top on route change
        window.scrollTo(0,0);
    
        // Hide header navigation for stories embed mode (to show on mobile native app)
        if((location.pathname.indexOf('/story') >= 0) && location.search === '?layout=embed'){
            setHeaderVisible(false);
        }
    }, [location]);

    useEffect(() => {
       if(config.config && config.config.cookie && config.config.cookie.enabled && config.config.cookie.enabled.indexOf(config.getCountry()) >= 0){
           setCookieEnabled(true);
       }
    }, [config]);

    useEffect(() => {
        // Set value for logo and campaign buttons
        if (cms.pages && cms.pages.content && cms.pages.content.url){
            setLogoUrl(cms.pages.content.url)
        }
        if(cms.siteSettings) {
            if(cms.siteSettings.logoDesktop && cms.siteSettings.logoDesktop.url) {
                setLogoDesktop(cms.siteSettings.logoDesktop.url)
            }
            if(cms.siteSettings.logoMobile && cms.siteSettings.logoMobile.url) {
                setLogoMobile(cms.siteSettings.logoMobile.url);
            }
            if(cms.siteSettings.campaignButtons) {
                if(cms.siteSettings.campaignButtons.login){
                    setLoginText(cms.siteSettings.campaignButtons.login.text);
                    setLoginUrl(cms.siteSettings.campaignButtons.login.url);
                }
                if(cms.siteSettings.campaignButtons.register){
                    setRegisterText(cms.siteSettings.campaignButtons.register.text);
                    setRegisterUrl(cms.siteSettings.campaignButtons.register.url);
                }
                if(cms.siteSettings.campaignButtons.donate){
                    setDonateText(cms.siteSettings.campaignButtons.donate.donateBtn.text);
                    let optionsList = [
                        {
                            text: cms.siteSettings.campaignButtons.donate.giveOnceBtn.text,
                            url: cms.siteSettings.campaignButtons.donate.giveOnceBtn.url
                        },
                        {
                            text: cms.siteSettings.campaignButtons.donate.giveMonthlyBtn.text,
                            url: cms.siteSettings.campaignButtons.donate.giveMonthlyBtn.url
                        },
                        {
                            text: cms.siteSettings.campaignButtons.donate.giveToAPersonBtn.text,
                            url: cms.siteSettings.campaignButtons.donate.giveToAPersonBtn.url
                        }
                    ];
                    if (config.getValue("donation.recurring.enabled").indexOf(config.getCountry()) < 0) {
                        optionsList.splice(1,1);
                    }
                    setDonateOptions(optionsList);
                } 
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cms]);

    useEffect(() => {
        if(helper.getCookie(helper.getUserCookieName('logged')) === '1'){
            setLoggedIn(true);
            // Header default height
            setHeaderHeight('75px'); 
        }
    }, [loggedIn]);

    function loggingOut() {
        fetch(`${helper.getLegacyAssetUrl('api', '/auth', config.getCountry() )}`, {method: 'DELETE'})
        .then(res => res.json())
        .then(
            success => {
                if(success.result){
                    setLoggedIn(false);
                    // Header height on mobile
                    setHeaderHeight(isOnMobile  ? '138px' : '75px');
                }
            },
            error => {
                console.log("Request error " + error);
            }
        ); 
    };

  function getUserInfo(info){
    switch(info){
      default:
      case 'firstname':
        let fullname = helper.getCookie(helper.getUserCookieName('name'));
        return fullname ? fullname.split('+')[0] : '';
      case 'image':
        let imageObj = decodeURIComponent(helper.getCookie(helper.getUserCookieName('pic')));
        return imageObj ? imageObj : null;
    }
  }
  
    return (
        headerVisible ?
        <Container height={headerHeight}>
            <StyledHeader>
                <HeaderLogo logo={logoDesktop} logoMobile={logoMobile}>
                    <Link to={logoUrl}></Link>
                </HeaderLogo>
                <Menu>
                    <CTAs>
                        <IconsGroup>
                            <Icon isSideMenu={true}>
                                <IconStart isVisible={!isComponentVisible} isSideMenu={true} onClick={()=> setIsComponentVisible(true)}/>
                                <IconClose isVisible={isComponentVisible} onClick={()=> setIsComponentVisible(false)}/>
                                 
                            </Icon>
                            <Icon IconStart>
                                <IconStart isVisible={!searching} onClick={() => setSearching(true)}/>
                                <IconClose isVisible={searching} onClick={() => setSearching(false)}/>
                            </Icon>
                        </IconsGroup>
                        <ButtonsGroup>
                            {loggedIn ? 
                            <LoggedIn>
                                <User onClick={() => setUserMenuVisible(!userMenuVisible)}>
                                    <FirstName>{getUserInfo('firstname')}</FirstName>
                                    <UserImage>
                                        <img  src={getUserInfo('image') ? helper.getBaseUrl(config.getCountry()) + getUserInfo('image') : null} alt="user-profile"/>
                                    </UserImage>
                                    <UserMenu isVisible={userMenuVisible} ref={clickOutsideWrapperRef}>
                                        { (cms.nav && cms.nav.loggedInMenu) &&
                                            <ul>
                                                { 
                                                    Object.keys(cms.nav.loggedInMenu).map(item => 
                                                    <React.Fragment key={item}>
                                                        {
                                                         item === 'logOut' ?
                                                         // eslint-disable-next-line
                                                         <LogOut><a onClick={()=> loggingOut()}>{cms.nav.loggedInMenu[item].text}</a></LogOut>
                                                         :<li><a href={cms.nav.loggedInMenu[item].link}>{cms.nav.loggedInMenu[item].text}</a></li>
                                                        }
                                                    </React.Fragment>
                                                )}
                                            </ul>
                                        }
                                    </UserMenu>
                                </User>
                            </LoggedIn>
                            : <Login href={loginUrl}>{loginText}</Login>}
                            { !(loggedIn && isOnMobile) &&
                                <CampaingButtons>
                                    {!loggedIn && <CampaingBtn href={registerUrl}>{registerText}</CampaingBtn>}
                                    <DropdownButton text={donateText} options={donateOptions} />
                                </CampaingButtons>
                            }
                        </ButtonsGroup>
                    </CTAs>
                    <Nav>
                        <NavMenu>
                            {cms.nav && (typeof cms.nav.siteNav === 'object') && Object.keys(cms.nav.siteNav).map(menu =>
                                <React.Fragment key={menu}>
                                    <NavItem>
                                        {/* eslint-disable-next-line */}
                                        <a href="#" onMouseEnter={()=> { setActiveMenu(menu !== 'stories' ? cms.nav.siteNav[menu].categories : cms.nav.siteNav[menu]); setIsHoverNav(true)}}
                                            onMouseLeave={()=> setIsHoverNav(false)}>
                                                {cms.nav.siteNav[menu].title}
                                        </a>
                                    </NavItem>
                                </React.Fragment>
                            )}
                        </NavMenu>
                        <MainNav cms={cms}  activeMenu={activeMenu} isHoverNav={isHoverNav}/>
                    </Nav>
                </Menu>
            </StyledHeader>

            {cms.nav &&
                <SideNavContainer ref={ref}>
                    <SideNav 
                        isVisible={isComponentVisible} 
                        cms={cms}
                        nav={cms.nav.siteNav} 
                        loggedIn={loggedIn} 
                        headerHeight={headerHeight}
                        onClose={() => setIsComponentVisible(false)}/>
                </SideNavContainer>
            }

            <SearchBar isVisible={searching} headerHeight={headerHeight}>
                <SearchForm>
                    <SearchInput placeholder={cms.snippets['text-common-search'].text}/>
                </SearchForm>
            </SearchBar>
            <LanguageBar/>
            {cookieEnabled && <CookieBar cms={cms} loggedIn={loggedIn} />}
        </Container>
        : null
    );
}

export default Header;
